// eslint-disable-next-line
export const resourceFrom = (resource) => Monet.I18n.getResourcesByKey(resource);

export const formatDate = (date) => Monet.Format.DateTime.formatToLocale(date);

export const checkIfDataExist = (dataItem) => dataItem ?? '-';
